<template>
  <!-- 内容左侧标签 -->
  <div class="content-left-tab">
    <div
      class="left-tab-swap"
      v-for="item in tabData"
      v-bind:key="item.id"
      :class="{ 'left-tab-swap-sel': selected === item.id }"
      v-on:click="TabChange(item)"
    >
      <div class="left-tab-line"></div>
      <div class="left-tab-link">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentLeftTab',
  props: {
    tabData: {
      type: Array,
      default: () => []
    },
    selectedTab: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selected: this.selectedTab
    }
  },
  computed: {},
  created() {},
  methods: {
    TabChange: function (item) {
      this.selected = item.id
      this.$emit('TabChange', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-left-tab {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 314px;
  border-radius: 4px;
  .left-tab-swap {
    cursor: pointer;
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    .left-tab-line {
      width: 4px;
      height: 54px;
      border-radius: 4px 0px 0px 4px;
    }
    .left-tab-link {
      width: 310px;
      height: 54px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #262626;
      border-radius: 0 4px 4px 0;
    }
  }
  .left-tab-swap-sel {
    .left-tab-line {
      background-color: #046bcc;
    }
    .left-tab-link {
      color: #046bcc;
      background-color: rgb(4, 107, 204, 0.1);
    }
  }
}
</style>
